import * as React from 'react';

const DemoModeBanner: React.FC = () => (
  <div className="bg-blue px-4 py-2 text-center font-bold text-white">
    DEMO Mode
  </div>
);

export { DemoModeBanner };
